import request from '../utils/request';

export interface PublicRegisterPayload {
  email: string;
  password: string;
  username?: string;
}

export interface EmailAvailabilityResult {
  available: boolean;
  normalized_email?: string;
  detail?: string;
}

export const registerPublicCustomer = async (payload: PublicRegisterPayload) => {
  const response = await request.post<{ detail: string }>('/api/v1/auth/register/', payload);
  return response.data;
};

export const verifyPublicRegisterEmail = async (token: string) => {
  const response = await request.post<{ detail: string }>('/api/v1/auth/verify-email/', { token });
  return response.data;
};

export const resendPublicVerifyEmail = async (email: string) => {
  const response = await request.post<{ detail: string }>('/api/v1/auth/resend-verify-email/', { email });
  return response.data;
};

export const checkEmailAvailability = async (email: string) => {
  const response = await request.get<EmailAvailabilityResult>('/api/v1/users/email-availability/', {
    params: { email },
  });
  return response.data;
};

export const forgotPassword = async (email: string) => {
  const response = await request.post<{ detail: string }>('/api/v1/auth/forgot-password/', { email });
  return response.data;
};

export const resetPasswordByToken = async (payload: {
  uid: string;
  token: string;
  new_password: string;
  confirm_password: string;
}) => {
  const response = await request.post<{ detail: string }>('/api/v1/auth/reset-password/', payload);
  return response.data;
};

export const changeMyPassword = async (payload: {
  current_password: string;
  new_password: string;
  confirm_password: string;
}) => {
  const response = await request.post<{ detail: string }>('/api/v1/auth/change-password/', payload);
  return response.data;
};

